import {
    IonButton,
    IonContent,
    IonPage,
    IonText,
    useIonRouter,
} from "@ionic/react";
import { Capacitor } from "@capacitor/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import HeroImage from "../../assets/images/registerOrLogin/hero.jpg";
import Logo from "../../assets/images/scorza-logo-watermark.svg";
import { getScorzaHomeUrlWithTracking } from "../../constants/urls";
import { routes } from "../../route/constants";
import "./registerOrLogin.css";

const openExternal = (url: string) => {
    if (Capacitor.getPlatform() === "web") {
        window.open(url, "_blank", "noopener");
    } else {
        window.open(url, "_system");
    }
};

export const RegisterOrLogin: FC = () => {
    const { t } = useTranslation();
    const route = useIonRouter();

    const homepageLink = useMemo(() => getScorzaHomeUrlWithTracking(), []);

    const handleHaveScorza = () => {
        route.push(routes.login, "root", "replace");
    };

    const handleDontHaveScorza = () => {
        openExternal(homepageLink);
    };

    return (
        <IonPage className="register-or-login">
            <IonContent
                fullscreen={true}
                data-testid="register-or-login-page"
                className="register-or-login__content"
            >
                <div
                    className="register-or-login__background"
                    style={{ backgroundImage: `url(${HeroImage})` }}
                />
                <div className="register-or-login__overlay" />

                <div className="register-or-login__body">
                    <div className="register-or-login__logo-block">
                        <img
                            src={Logo}
                            alt="SCORZA logo"
                            className="register-or-login__logo"
                        />
                        <IonText className="register-or-login__tagline">
                            {t("register.registerOrLogin.tagline")}
                        </IonText>
                    </div>

                    <div className="register-or-login__actions">
                        <IonButton
                            expand="block"
                            size="large"
                            className="register-or-login__btn register-or-login__btn--secondary"
                            data-testid="register-or-login-dont-have-scorza"
                            onClick={handleDontHaveScorza}
                        >
                            {t("register.registerOrLogin.primaryCta")}
                        </IonButton>
                        <IonButton
                            expand="block"
                            size="large"
                            className="register-or-login__btn register-or-login__btn--primary"
                            data-testid="register-or-login-have-scorza"
                            onClick={handleHaveScorza}
                        >
                            {t("register.registerOrLogin.secondaryCta")}
                        </IonButton>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};
